import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/categories';

export default function CategoryGrid({ limit }) {
  const list = limit ? categories.slice(0, limit) : categories;
  return (
    <div className="category-grid">
      {list.map((cat) => (
        <Link to={`/categoria/${cat.slug}`} key={cat.slug} className="category-card">
          <span className="category-icon">{cat.icon}</span>
          <h3>{cat.name}</h3>
          <p>{cat.description}</p>
        </Link>
      ))}
    </div>
  );
}
